export default "/images/vendor/flag-icons/flags/4x3/kh.svg?ffda5c64882c0293dab053442c4a1db0";